"use client"

import { Fragment } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"

import { usePortalChrome } from "@/components/site/portal-chrome-context"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { getPortalBreadcrumbs } from "@/lib/site-nav"

/** Хлебные крошки внутренних страниц портала (на главной скрыты). */
export function SiteBreadcrumbs({ embedded = false }: { embedded?: boolean }) {
  const pathname = usePathname()
  const { pagesIndex } = usePortalChrome()
  const crumbs = getPortalBreadcrumbs(pathname, pagesIndex)

  if (crumbs.length < 2) return null
  if (!embedded && pathname.startsWith("/km")) return null

  const trail = (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1
          return (
            <Fragment key={`${crumb.label}-${index}`}>
              {index > 0 ? <BreadcrumbSeparator /> : null}
              <BreadcrumbItem>
                {isLast || !crumb.href ? (
                  <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                ) : (
                  <Link
                    href={crumb.href}
                    prefetch={crumb.href.startsWith("/km") ? false : undefined}
                    className="cursor-pointer transition-colors hover:text-foreground"
                  >
                    {crumb.label}
                  </Link>
                )}
              </BreadcrumbItem>
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )

  if (embedded) {
    return (
      <div className="border-b border-border bg-background">
        <div className="mx-auto max-w-6xl px-4 py-2.5 sm:px-6">{trail}</div>
      </div>
    )
  }

  return (
    <div>
      <div className="mx-auto max-w-6xl px-4 py-2.5 sm:px-6">{trail}</div>
    </div>
  )
}
